import { supabase } from '@/lib/supabase';
import { ProjectWithContractors } from '@/shared/types/api';

export const getProjectSubprojects = async ({
  projectId,
}: {
  projectId: number;
}): Promise<ProjectWithContractors[]> => {
  const { data, error } = await supabase.rpc(
    'get_filtered_project_subprojects',
    {
      p_project_id: projectId,
    },
  );

  if (error) {
    throw error;
  }

  return (data as ProjectWithContractors[]).map((project) => ({
    ...project,
    contractors: project.contractors.filter(
      (contractor, index, self) =>
        index === self.findIndex((t) => t.id === contractor.id),
    ),
  }));
};
